import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IContentItem } from '../../../../core/models/content-item.model';

/**
 * One piece of content in the coach's library view: what it is, when it went out and whether this
 * student already has it as a task. The card only reports clicks — fetching the detail, playing it
 * and writing the task all belong to the tab that hosts it.
 */
@Component({
  selector: 'coach-content-card',
  templateUrl: './content-card.component.html',
  styleUrl: './content-card.component.scss',
})
export class ContentCardComponent {
  @Input() item!: IContentItem;
  /** Set once this student has a task pointing at it; the card then offers nothing to click. */
  @Input() isAssigned = false;
  @Input() studentName?: string | null;

  @Output() previewRequested = new EventEmitter<IContentItem>();
  @Output() assignRequested = new EventEmitter<IContentItem>();
}
